import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../lib/api';
import { formatDate, formatIDR } from '../../lib/format';
import AdminLayout from '../../components/AdminLayout';
import { Card } from '../../components/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { StatusBadge } from '../../components/StatusBadge';

function List({ query }) {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/admin/memberships?${query}`).then(r => setItems(r.data.memberships)).catch(()=>{}); }, [query]);
  return (
    <Card className="p-0 overflow-hidden mt-2"><div className="overflow-x-auto">
      <Table><TableHeader><TableRow><TableHead>Nama</TableHead><TableHead>Email</TableHead><TableHead>Status</TableHead><TableHead>Mulai</TableHead><TableHead>Expiry</TableHead><TableHead>Snapshot</TableHead></TableRow></TableHeader>
        <TableBody>{items.length===0 && <TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">Tidak ada data</TableCell></TableRow>}
          {items.map(m => (<TableRow key={m.user_id} className="cursor-pointer hover:bg-muted/40" onClick={()=>nav(`/admin/members/${m.user_id}`)}><TableCell className="font-medium">{m.name}</TableCell><TableCell className="text-xs">{m.email}</TableCell><TableCell><StatusBadge status={m.status} /></TableCell><TableCell className="text-xs">{m.membership_start_date?formatDate(m.membership_start_date):'-'}</TableCell><TableCell className="text-xs">{m.membership_expiry_date?formatDate(m.membership_expiry_date):'-'}</TableCell><TableCell className="text-xs">{m.membership_price_snapshot?formatIDR(m.membership_price_snapshot):'-'}</TableCell></TableRow>))}</TableBody>
      </Table>
    </div></Card>
  );
}

export default function AdminMemberships() {
  return (
    <AdminLayout title="Memberships">
      <Tabs defaultValue="active">
        <TabsList><TabsTrigger value="active">Active</TabsTrigger><TabsTrigger value="expiring">Expiring Soon</TabsTrigger><TabsTrigger value="expired">Expired</TabsTrigger><TabsTrigger value="suspended">Suspended</TabsTrigger><TabsTrigger value="pending">Pending</TabsTrigger></TabsList>
        <TabsContent value="active"><List query="status=ACTIVE" /></TabsContent>
        <TabsContent value="expiring"><List query="expiring=30" /></TabsContent>
        <TabsContent value="expired"><List query="status=EXPIRED" /></TabsContent>
        <TabsContent value="suspended"><List query="status=SUSPENDED" /></TabsContent>
        <TabsContent value="pending"><List query="status=PENDING" /></TabsContent>
      </Tabs>
    </AdminLayout>
  );
}
